import { render, staticRenderFns } from "./sidepassun.vue?vue&type=template&id=22340a3f&scoped=true&"
import script from "./sidepassun.vue?vue&type=script&lang=js&"
export * from "./sidepassun.vue?vue&type=script&lang=js&"
import style0 from "./sidepassun.vue?vue&type=style&index=0&id=22340a3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22340a3f",
  null
  
)

export default component.exports